import React from "react";
import { ArrowLeft, Eye, Bookmark, Pin, Calendar } from "lucide-react";
import LocalDateTime from "services/date-converter";
import { useAccentColor } from "utils/accent-color";
import ArticleHero from "./ArticleHero";

const ArticleHeader = ({ article, onBack, onToggleBookmark, onTogglePin }) => {
  const accent = useAccentColor(article.knowledge_base?.color_code);

  return (
    <div className="bg-surface border-b border-border">
      {/* Chapter colour rule — keeps the reader page tied to the chapter the
          article came from, which the hub grid also colours. */}
      <div className="h-1" style={{ backgroundColor: accent.base }} />

      <div className="px-4 sm:px-6 pt-4">
        <button
          type="button"
          onClick={onBack}
          className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium text-text_secondary border border-border"
        >
          <ArrowLeft size={13} />
          Back to Knowledge Base
        </button>
      </div>

      <div className="mt-4">
        <ArticleHero article={article} />
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <div className="flex items-center flex-wrap gap-x-4 gap-y-2 text-xs text-text_muted">
          <span className="inline-flex items-center gap-1.5">
            <Calendar size={12} />
            <LocalDateTime utcTime={article.published_at} type="date" />
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Eye size={12} />
            {article.engagement?.total_views || 0} views
          </span>
        </div>

        <div className="flex items-center gap-2.5 mt-5">
          <button
            type="button"
            onClick={onToggleBookmark}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold ${
              article.viewer_state?.is_bookmarked
                ? "bg-primary_tint text-primary border-primary/40"
                : "bg-surface text-text_secondary border-border"
            }`}
          >
            <Bookmark size={13} className={article.viewer_state?.is_bookmarked ? "fill-current" : ""} />
            {article.viewer_state?.is_bookmarked ? "Bookmarked" : "Bookmark"}
          </button>
          <button
            type="button"
            onClick={onTogglePin}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold ${
              article.viewer_state?.is_pinned
                ? "bg-warning_bg text-warning border-warning_border"
                : "bg-surface text-text_secondary border-border"
            }`}
          >
            <Pin size={13} className={article.viewer_state?.is_pinned ? "fill-current" : ""} />
            {article.viewer_state?.is_pinned ? "Pinned" : "Pin"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArticleHeader;
